var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":"Access Restricted","ok-only":true},on:{"ok":_vm.redirectDashboard},model:{value:(_vm.showAccessModal),callback:function ($$v) {_vm.showAccessModal=$$v},expression:"showAccessModal"}},[_vm._v(" Sorry, but you do not have access to Post at this time. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }